/**
 * localStorage persistence for the `debug` slice of `AppState`.
 * Viewer-only, never synced to the server.
 */
const STORAGE_KEY = "explorer-debug";
const DEFAULTS = { showWipBorder: false };
export function loadDebugState() {
    if (typeof window === "undefined")
        return DEFAULTS;
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored)
            return DEFAULTS;
        const parsed = JSON.parse(stored);
        return { ...DEFAULTS, ...parsed };
    }
    catch (e) {
        console.warn("Failed to load debug state:", e);
        return DEFAULTS;
    }
}
export function saveDebugState(state) {
    if (typeof window === "undefined")
        return;
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }
    catch (e) {
        console.warn("Failed to save debug state:", e);
    }
}
